var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.119,
    height: 36.82,
    viewBox: "0 0 100.119 36.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(-65 -1015.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(65 1015.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_57",
    "data-name": "Union 57",
    d: "M7.868,36.82a.727.727,0,1,1,0-1.455H13.9a.727.727,0,1,1,0,1.455Zm-.311-3.256L5.944,26.528l-4.164.758L1.627,26.6C1.522,26.132-.938,14.972.395,8.5A10.333,10.333,0,0,1,8.01.347.729.729,0,0,1,8.219.335,10.8,10.8,0,0,1,20.952,6.969a9.959,9.959,0,0,1,.526,1.838.725.725,0,0,1,.215.378c.711,3.274-1.223,16.5-1.305,17.065l-.1.69-4.39-.461-1.448,7.085Zm1.159-1.456h4.544l1.475-7.216,4.313.452c.336-2.372.848-6.381,1.136-9.842a9.887,9.887,0,0,1-5.264,4.1,7.913,7.913,0,0,1-2.665.36,8.254,8.254,0,0,1-7.47-5.345A7.367,7.367,0,0,1,9.4,4.905a5.819,5.819,0,0,1,7.044,3.479,5,5,0,0,1-3.2,6.7A3.2,3.2,0,0,1,9.289,13.2,2.932,2.932,0,0,1,11.081,9.42c.8-.234,1.276,1,.481,1.239a1.616,1.616,0,0,0-1.036,2.148,1.773,1.773,0,0,0,2.236,1.04,3.748,3.748,0,0,0,2.449-5.07A4.347,4.347,0,0,0,9.884,6.144a6.057,6.057,0,0,0-3.863,8.078,6.909,6.909,0,0,0,8.417,4.138A8.4,8.4,0,0,0,20.364,10.2a5.327,5.327,0,0,0-.093-.708.716.716,0,0,1,.009-.345,9.194,9.194,0,0,0-.474-1.87,9.466,9.466,0,0,0-11.139-5.7.728.728,0,0,1-.359.193A8.889,8.889,0,0,0,1.821,8.791C.732,14.079,2.39,23.065,2.9,25.6l4.147-.756Z",
    transform: "translate(0 0)",
    fill: "#2b64e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40985",
    "data-name": "Path 40985",
    d: "M1.42,0H3.76V-5.76h6.66V-7.82H3.76v-3.46h6.8v-2.06H1.42ZM12.66-5.26c0,3.28,1.9,5.5,5.78,5.5,3.86,0,5.76-2.2,5.76-5.52v-8.06H21.84v8a3.161,3.161,0,0,1-3.4,3.5,3.167,3.167,0,0,1-3.42-3.5v-8H12.66ZM36.34,0H38.6V-13.34H36.26v9.46l-6.82-9.46h-2.4V0h2.34V-9.72Zm5.1,0H46.4c4.16,0,6.98-2.74,6.98-6.66s-2.82-6.68-6.98-6.68H41.44Zm2.34-2.06v-9.22H46.4a4.322,4.322,0,0,1,4.58,4.62,4.381,4.381,0,0,1-4.58,4.6ZM64.38,0h2.56L61.7-13.34H58.78L53.54,0H56.1l.98-2.56H63.4ZM60.24-11.36l2.5,6.74h-5Z",
    transform: "translate(98.179 1040)",
    fill: "#2b64e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundaLogo);
export default __webpack_public_path__ + "static/media/FundaLogo.f4596ff7d43883d6036acb4122ab7da9.svg";
export { ForwardRef as ReactComponent };